import { useState, useEffect } from 'react';
import { quotes } from '@/mocks/quotes';

export default function QuotesSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % quotes.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-primary-500">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-white mb-8 md:mb-10">
          读者心声
        </h2>

        <div className="relative overflow-hidden">
          <div
            className="transition-opacity duration-700"
            key={current}
          >
            <blockquote className="px-4">
              <p className="text-lg md:text-xl text-white leading-relaxed font-heading">
                &ldquo;{quotes[current].content}&rdquo;
              </p>
              <footer className="mt-4 text-sm text-white/80">
                {quotes[current].author}
              </footer>
            </blockquote>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2">
            {quotes.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === current
                    ? 'bg-white w-5'
                    : 'bg-white/40 hover:bg-white/60'
                }`}
                aria-label={`第${index + 1}条读者心声`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}